"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyType = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const NotifyType = ({
  currentType,
  onChange
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    config
  } = (0, _contexts.useAppContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const [isSelected, setIsSelected] = (0, _react.useState)(currentType !== _models.BackInStockNotificationChannel.Email);
  const handleChange = (0, _react.useCallback)(({
    currentTarget: {
      checked
    }
  }) => {
    setIsSelected(checked);
    onChange(checked ? _models.BackInStockNotificationChannel.Sms : _models.BackInStockNotificationChannel.Email);
  }, [onChange]);
  if (!config?.smsSubscriptionEnabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    fullWidth: true,
    "data-testid": getTestId(_constants.NOTIFY_TYPE),
    checked: isSelected,
    firstText: translations.email,
    secondText: translations.sms,
    role: "radiogroup",
    onChange: handleChange
  });
};
exports.NotifyType = NotifyType;